<template>
  <div class="ioRecord">
    <!-- <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick" :moduleName="moduleName"></AreaTree>
    </div> -->
    <div class="right">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label>集团:</label>
            <el-select filterable v-model="search.groupId" placeholder="请选择集团">
              <el-option
                v-for="item in groupList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label for="bdate">开始时间:</label>
            <el-date-picker
              clearable
              value-format="yyyy-MM"
              v-model="search.beginTime"
              type="month"
            ></el-date-picker>
          </div>
          <div class="form-group">
            <label for="bdate">结束时间:</label>
            <el-date-picker
              clearable
              value-format="yyyy-MM"
              v-model="search.endTime"
              type="month"
            ></el-date-picker>
          </div>

          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
                :disabled="loading">
              <i v-if="loading" class="el-icon-loading"></i>
              {{ loading ? "查询中..." : "查询" }}
            </button>
            </span>
            <span class="download_btn">
              <button
                @click="downloadData"
                type="button"
                class="btn btn-primary"
                :disabled="exportLoading"
              >
                <i v-if="exportLoading" class="el-icon-loading"></i>
                {{ exportLoading ? "导出中..." : "导出" }}
            </button>
            </span>
          </div>
          <!-- <span class="switchGroup">
            <el-select v-model="switchValue" placeholder="请选择展示类型">
              <el-option value="list" label="列表">
                <span class="switch">
                  <img src="@/assets/images/temp/liebiao.png" width="16px" />
                  <span class="switch-info">列表</span>
                </span>
              </el-option>
              <el-option value="chart" label="图表">
                <span class="switch">
                  <img src="@/assets/images/temp/tubiao.png" width="16px" />
                  <span class="switch-info">图表</span>
                </span>
              </el-option>
            </el-select>
          </span> -->
        </form>
      </div>
      <div>
        <template>
          <!-- <div v-show="showChart" id="myChart" style="width:950px;height:450px;"></div> -->
          <div v-show="showList" class="list-right" v-loading='loading' element-loading-text="加载中...">
            <el-table
              ref="table"
              border
              :data="tableListData"
              height="100%"
              :header-cell-style="tableHeaderStyle"
              :cell-style="tableCellStyle"
            >
              <!-- 统计时间 -->
              <el-table-column
                fixed="left"
                show-overflow-tooltip
                label="统计时间"
                prop="date"
                width="120"
              ></el-table-column>
              <!-- 本月总实收 -->
              <el-table-column
                show-overflow-tooltip
                label="本月总实收"
                prop="_totalIncome"
              ></el-table-column>
              <!-- 临停缴费（7子项） -->
              <el-table-column label="临停缴费">
                <el-table-column show-overflow-tooltip label="应收总额(创建)" prop="_receivableCrt" width="120"></el-table-column>
                <el-table-column show-overflow-tooltip label="应收总额(支付)" prop="_receivable" width="120"></el-table-column>
                 <el-table-column show-overflow-tooltip label="实收总额(含追缴)" prop="_realTotalWithArrears" width="120"></el-table-column>
                <el-table-column show-overflow-tooltip label="微信（含追缴）" prop="_wechatWithArrears" width="120"></el-table-column>
                <el-table-column show-overflow-tooltip label="支付宝（含追缴）" prop="_alipayWithArrears" width="120"></el-table-column>
                <el-table-column show-overflow-tooltip label="余额（含追缴）" prop="_balanceWithArrears" width="120"></el-table-column>
                <el-table-column show-overflow-tooltip label="现金（含追缴）" prop="_cashWithArrears" width="120"></el-table-column>
                <el-table-column show-overflow-tooltip label="实收总额(无追缴)" prop="_realTotal" width="120"></el-table-column>
                <el-table-column show-overflow-tooltip label="微信（无追缴）" prop="_wechat" width="120"></el-table-column>
                <el-table-column show-overflow-tooltip label="支付宝（无追缴）" prop="_alipay" width="120"></el-table-column>
                <el-table-column show-overflow-tooltip label="余额（无追缴）" prop="_balance" width="120"></el-table-column>
                <el-table-column show-overflow-tooltip label="现金（无追缴）" prop="_cash" width="120"></el-table-column>
               
                <el-table-column show-overflow-tooltip label="未缴费" prop="unpay"></el-table-column>
              </el-table-column>
              <!-- 追缴欠费（3子项） -->
              <el-table-column label="追缴欠费">
                <el-table-column show-overflow-tooltip label="总计(支付)" prop="_arrearsTotal" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip label="道路追缴欠费(支付)" prop="_roadArrears" width="130"></el-table-column>
                <el-table-column show-overflow-tooltip label="车场追缴欠费(支付)" prop="_parkArrears" width="130"></el-table-column>
              </el-table-column>
              <!-- 月租续费 -->
              <el-table-column show-overflow-tooltip label="月租续费" prop="_monthlyRent"></el-table-column>
              <!-- 小程序充值 -->
              <el-table-column show-overflow-tooltip label="小程序充值" prop="_recharge"></el-table-column>
              <!-- 收费率 -->
              <el-table-column show-overflow-tooltip label="收费率" prop="collectionRate"></el-table-column>
            </el-table>
          </div>
        </template>
      </div>
      <!-- <Page :pageSize="search.pageSize"></Page> -->
      <Page v-show="showList" v-on:pagination="receivePaginationData"></Page>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import {
  getGroupMonthReportList,
  getGroupMonthList,
  fetchGroupList,
} from "@/api/url";
import AreaTree from "../../commons/areaTree";
import Page from "../../commons/page";
import dayjs from 'dayjs';
// import Refresh from '../commons/refresh.vue';
export default {
  data() {
    return {
      exportLoading: false,
      moduleName: "property",
      styleObj: {
        "text-align": "center",
      },
      // body 单元格列分组斑马纹，与表头一致
      cellGroupIndex: {
        date: 0,
        _totalIncome: 1,
        _receivable: 2, _receivableCrt: 2, _realTotal: 2, _realTotalWithArrears: 2, _wechat: 2, _alipay: 2, _balance: 2, _cash: 2, _wechatWithArrears: 2, _alipayWithArrears: 2, _balanceWithArrears: 2, _cashWithArrears: 2, unpay: 2,
        _arrearsTotal: 3, _roadArrears: 3, _parkArrears: 3,
        _monthlyRent: 4,
        _recharge: 5,
        collectionRate: 6,
      },
      groupList: [],
      tableListData: [],
      tableListDataTitle: [],
      switchValue: "list",
      showList: true,
      showChart: false,
      search: {
        pageSize: 10,
        pageNumber: 1,
        beginTime: dayjs().subtract(1,'month').format('YYYY-MM'),
        endTime: dayjs().format('YYYY-MM'),
        groupId: null,
      },
      loading: false,
      // myChart: {
      //   title: {
      //     text: "",
      //   },
      //   tooltip: {
      //     trigger: "axis",
      //   },
      //   legend: {
      //     data: ["收入总额", "未缴费", "追缴欠费(总额)"],
      //   },
      //   grid: {
      //     left: "3%",
      //     right: "4%",
      //     bottom: "3%",
      //     containLabel: true,
      //   },
      //   toolbox: {
      //     // feature: {
      //     // 	saveAsImage: {}
      //     // }
      //   },
      //   xAxis: [
      //     {
      //       type: "category",
      //       axisLabel: {
      //         interval: 0,
      //         rotate: 40,
      //         color: "#333333",
      //       },
      //       name: "日期",
      //       data: [],
      //     },
      //   ],
      //   yAxis: {
      //     type: "value",
      //   },
      //   series: [
      //     {
      //       name: "收入总额",
      //       type: "line",
      //       data: [],
      //     },
      //     {
      //       name: "未缴费",
      //       type: "line",
      //       data: [],
      //     },
      //     {
      //       name: "追缴欠费(总额)",
      //       type: "line",
      //       data: [],
      //     },
      //   ],
      // },
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    tableCellStyle({ column }) {
      const idx = this.cellGroupIndex[column.property] ?? -1;
      const bg = idx >= 0 && idx % 2 === 1 ? "#ECF5FF" : "#FFFFFF";
      return { "text-align": "center", "background-color": bg + " !important" };
    },
    tableHeaderStyle({ rowIndex, column }) {
      const base = { "text-align": "center" };
      const prop = column.property;
      const label = column.label;

      // 大列分组序号：统计时间=0, 本月总实收=1, 临停缴费=2, 追缴欠费=3, 月租续费=4, 小程序充值=5, 收费率=6
      const groupIndex = {
        date: 0,
        _totalIncome: 1,
        _receivable: 2, _receivableCrt: 2, _realTotal: 2, _realTotalWithArrears: 2, _wechat: 2, _alipay: 2, _balance: 2, _cash: 2, _wechatWithArrears: 2, _alipayWithArrears: 2, _balanceWithArrears: 2, _cashWithArrears: 2, unpay: 2,
        _arrearsTotal: 3, _roadArrears: 3, _parkArrears: 3,
        _monthlyRent: 4,
        _recharge: 5,
        collectionRate: 6,
      };
      const labelGroup = { "临停缴费": 2, "追缴欠费": 3 };
      const idx =
        rowIndex === 0 && labelGroup[label] != null
          ? labelGroup[label]
          : groupIndex[prop] ?? -1;

      const bg = idx >= 0 && idx % 2 === 1 ? "#ECF5FF" : "#FFFFFF";
      return { ...base, "background-color": bg + " !important" };
    },
    bindTableScrollSync() {
      const table = this.$refs.table?.$el;
      if (!table) return;

      const headerWrapper = table.querySelector('.el-table__header-wrapper');
      const bodyWrapper = table.querySelector('.el-table__body-wrapper');
      if (!headerWrapper || !bodyWrapper) return;

      // 单向同步：仅 body 横向滚动时驱动表头，避免双向回写导致最右列错位
      bodyWrapper.addEventListener('scroll', () => {
        headerWrapper.scrollLeft = bodyWrapper.scrollLeft;
      }, { passive: true });
    },
    // 修正：body 出现纵向滚动条时，用 marginRight 收缩表头宽度以匹配 body，避免横向滚到最右列错位
    syncHeaderScrollbar() {
      const table = this.$refs.table;
      if (!table) return;
      const bodyWrap = table.$el.querySelector(".el-table__body-wrapper");
      const headerWrap = table.$el.querySelector(".el-table__header-wrapper");
      if (!bodyWrap || !headerWrap) return;
      const hasVScroll = bodyWrap.scrollHeight > bodyWrap.clientHeight + 1;
      const barW = hasVScroll ? (bodyWrap.offsetWidth - bodyWrap.clientWidth) : 0;
      // 用 marginRight 让表头可滚动区比 body 窄一个滚动条宽，保证最右列对齐
      headerWrap.style.marginRight = barW > 0 ? barW + "px" : "";
    },
    withExportLoading(task) {
      if (this.exportLoading) return;
      this.exportLoading = true;
      let released = false;
      const release = () => {
        if (released) return;
        released = true;
        this.exportLoading = false;
      };
      const timer = setTimeout(release, 1500);
      try {
        const request = task();
        if (request && typeof request.finally === "function") {
          return request.finally(() => {
            clearTimeout(timer);
            release();
          });
        }
        return request;
      } catch (error) {
        clearTimeout(timer);
        release();
        throw error;
      }
    },

    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    //点击树的节点展示相应数据
    // handleTreeClick: function (node, data) {
    //   this.search.beginTime = "";
    //   this.search.endTime = "";
    //   if (node.type == "group") {
    //     this.treeData.groupId = node.id;
    //     if (this.showList) {
    //       this.search.pageNumber = 1;
    //       this.tableList(this.search.pageNumber);
    //     }
    //     if (this.showChart) {
    //       this.echarts();
    //     }
    //   } else {
    //     this.treeData.groupId = "";
    //     this.tableListData = [];
    //     var pageObj = {
    //       curIndex: 1,
    //       rowsCount: 0,
    //     };
    //     this.getPage(pageObj);
    //     //  this.$message({
    //     // 	message: '请选择车场！',
    //     // 	type: 'warning'
    //     // 	});
    //   }
    // },
    tableList: function (curPage) {
      var _this = this;
      this.loading=true;
      this.$get(getGroupMonthReportList(), {
        page: curPage,
        limit: this.search.pageSize,
        groupId: this.search.groupId,
        beginTime: this.search.beginTime,
        endTime: this.search.endTime,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData = data.data.rows.map((row) => {
          const toNum = (v) => Number(v || 0);
          return {
            ...row,
            _totalIncome: row.todayRealAmount,
            _monthlyRent: row.monthlycarMoney,
            _recharge: row.rechargeMoney,
            _arrearsTotal: row.arrears,
            _roadArrears: toNum(row.road_arrears).toFixed(2),
            _parkArrears: toNum(row.onsiteCollectionPayTime).toFixed(2),
            collectionRate: Math.min(toNum(row.collectionRate), 100).toFixed(2) + "%",
            _realTotal: toNum(row.real_money_non_arrears).toFixed(2),
            _realTotalWithArrears: toNum(row.real_money).toFixed(2),
            _receivableCrt: toNum(row.total_receivable_crt_time).toFixed(2),
            _wechat: toNum(row.real_money_non_arrears_wechat).toFixed(2),
            _alipay: toNum(row.real_money_non_arrears_alipay).toFixed(2),
            _balance: toNum(row.real_money_non_arrears_balance).toFixed(2),
            _cash: toNum(row.real_money_non_arrears_cash).toFixed(2),
            _wechatWithArrears: toNum(row.wechat).toFixed(2),
            _alipayWithArrears: toNum(row.alipay).toFixed(2),
            _balanceWithArrears: toNum(row.balance).toFixed(2),
            _cashWithArrears: toNum(row.cash).toFixed(2),
            _receivable: toNum(row.total_receivable).toFixed(2),
          };
        });
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
          _this.syncHeaderScrollbar();
        });
      }).finally(()=>{
        this.loading=false;
      })
    },
    // 图表
    // echarts: function () {
    //   var _this = this;
    //   this.$get(getGroupMonthList(), {
    //     groupId: this.treeData.groupId,
    //     beginTime: this.search.beginTime,
    //     endTime: this.search.endTime,
    //   }).then((data) => {
    //     this.myChart.series[0].data = [];
    //     this.myChart.series[1].data = [];
    //     this.myChart.series[2].data = [];
    //     this.myChart.xAxis[0].data = [];
    //     if (data.status != 200) return;
    //     for (var i in data.data.rows) {
    //       this.myChart.series[0].data.push(data.data.rows[i].real_money);
    //       this.myChart.series[1].data.push(data.data.rows[i].unpay);
    //       this.myChart.series[2].data.push(data.data.rows[i].arrears);
    //       this.myChart.xAxis[0].data.push(data.data.rows[i].date);
    //     }
    //     _this.$nextTick(() => {
    //       _this.$refs.table.doLayout();
    //     });
    //     let myChart = this.$echarts.init(document.getElementById("myChart"));
    //     myChart.setOption(this.myChart);
    //   });
    // },
    searchList: function () {
      if (this.loading) return;
      var flTime = this.timeCompare(this.search.beginTime, this.search.endTime);
      if (flTime) {
        return this.$layer.msg("开始时间请勿大于结束时间", { time: 1 });
      } else if (
        !Boolean(this.search.beginTime) 
      ) {
        return this.$layer.msg("请选择开始时间", { time: 1 });
      } else if (
        !Boolean(this.search.endTime)
      ) {
        return this.$layer.msg("请选择结束时间", { time: 1 });
      }

      var compareTime = this.timeCompare(dayjs(this.search.beginTime).add(12,'month').format('YYYY-MM'),this.search.endTime);     

      if (!compareTime) {
        return this.$layer.msg("请选择十二个月以内的日期", { time: 1 });
      }

      // if (this.treeData.groupId) {
      if (this.showList) {
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
      }
      if (this.showChart) {
        this.echarts();
      }
      // } else {
      //   this.$message({
      //     message: "请选择集团！",
      //     type: "warning",
      //   });
      // }
    },
    timeCompare: function (bDateVal, eDateVal) {
      if (!Boolean(bDateVal) || !Boolean(eDateVal)) {
        return false;
      }
      var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
      bdate = bdate.getTime();
      var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
      edate = edate.getTime();
      if (bdate - edate > 0) {
        return true;
      } else {
        return false;
      }
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.fbMsg = "";
      this.tableList(this.search.pageNumber);
    },
    getGroupList() {
      return this.$get(fetchGroupList()).then((res) => {
        const { status, data } = res;
        if (status === 200) {
          this.groupList = data;
        }
      });
    },
    async initGroup() {
      await this.getGroupList();
      this.search.groupId = this.groupList[0].id;
      this.tableList(this.search.pageNumber);
    },
    downloadData() {
      return this.withExportLoading(() =>
        this.$downloadFileRequest(
        "/api/parking/parkingOrders/groupMonthlyStatementExport",
        {
          groupId: this.search.groupId,
          beginTime: this.search.beginTime,
          endTime: this.search.endTime,
        },
        "集团月报"
      )
      );
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      nodeData: (state) => state.nodeData,
      nod: (state) => state.nod,
    }),
  },
  components: {
    Page,
    AreaTree,
  },

  mounted: function () {
    this.initGroup();
    this.$nextTick(() => {
      this.bindTableScrollSync();
    });
    window.addEventListener("resize", this.syncHeaderScrollbar);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.syncHeaderScrollbar);
  },
  // watch: {
  //   switchValue: function (newVal, oldVal) {
  //     if (newVal === "chart") {
  //       this.showChart = true;
  //       this.showList = false;
  //       if (this.treeData.groupId) {
  //         this.echarts();
  //       }
  //     } else {
  //       this.showChart = false;
  //       this.showList = true;
  //       if (this.treeData.groupId) {
  //         this.tableList(this.curIndex);
  //       }
  //     }
  //   },
  // },
};
</script>

<style scoped>
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
#myChart {
  overflow-x: auto;
}
.form-group .switchGroup {
  margin-left: 50px;
  display: flex;
  align-items: center;
}
.switch-info {
  display: inline-block;
  margin-left: 5px;
}
.show-list {
  height: 500px;
}
</style>
<style>
.ioRecord .el-select {
  width: 100px;
}
.switchGroup .el-input__inner {
  border: 1px solid #67c23a;
  border-radius: 4px;
}

/* ========== 修复多级表头横向滚动错位 ========== */

/* 1. 表头本身不独立滚动，横向由 body 驱动（JS 单向同步） */
.ioRecord .el-table__header-wrapper {
  overflow: hidden !important;
}

/* 2. body 横向滚动支持 */
.ioRecord .el-table__body-wrapper {
  overflow-x: auto !important;
}

/* 3. 消除 border 导致的 1px 累积偏差 */
.ioRecord .el-table--border .el-table__cell {
  box-sizing: border-box !important;
}
</style>